import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { CommonSharedModule } from '../common/shared.module';
import { EngagementCountComponent } from '../engagement-dashboard/engagement-count/engagement-count.component';
import { CustomerAcknoledgmentListComponent } from '../engagement-dashboard/customer-acknowledgment-list/customer-acknowledgment-list.component';
import { FindingDocReviewListComponent } from '../engagement-dashboard/finding-doc-review-list/finding-doc-review-list.component';
import { InvoiceDocReviewListComponent } from '../engagement-dashboard/invoice-doc-review-list/invoice-doc-review-list.component';
import { CustomerSurveyReviewListComponent } from '../engagement-dashboard/customer-survey-review-list/customer-survey-review-list.component';
import { AllEngagementListComponent } from '../engagement-dashboard/all-engagement-list/all-engagement-list.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [
    CommonSharedModule,
    EngagementCountComponent,
    CustomerAcknoledgmentListComponent,
    FindingDocReviewListComponent,
    InvoiceDocReviewListComponent,
    CustomerSurveyReviewListComponent,
    AllEngagementListComponent
  ],
  standalone: true
})
export class HomeComponent implements OnInit {
  tabList!: HomeTabDetailsModel[];

  get isProdEnvironment(): boolean {
    return environment.isProdEnvironment;
  }

  ngOnInit() {
    this.tabList = [
      new HomeTabDetailsModel(true, true),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel()
    ];
  }

  get isEngagmentCountSelected(): boolean {
    return this.tabList[0].isTabSelected;
  }

  onTabChange(event) {
    this.tabList.forEach(tab => {
      tab.isTabSelected = false;
    });
    this.tabList[event.index].hasTabLoaded = true;
    this.tabList[event.index].isTabSelected = true;
  }
}

export class HomeTabDetailsModel {
  hasTabLoaded: boolean;
  isTabSelected: boolean;

  constructor(hasTabLoaded = false, isTabSelected = false) {
    this.hasTabLoaded = hasTabLoaded;
    this.isTabSelected = isTabSelected;
  }
}
